import { css } from 'jimu-core';
export const formTextStyles = (props) => {
    var _a;
    const theme = props.theme;
    const formVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.form;
    return formVars && css `
    display: block;
    margin-top: ${formVars.helpText.marginTop};
    font-size: 0.8125rem;
  `;
};
